<template>
  <div
    class="sli-icon-file"
    :class="{
      'is-on': hasFile,
      'is-off': !hasFile,
      'is-disabled': disabled && !readonly,
      'sli-icon-file--legend': variant === 'legend',
      'sli-icon-file--legend': variant === 'legend',
    }"
  >
    <input
      :id="inputId"
      :key="fileKey"
      type="file"
      :accept="accept"
      :disabled="disabled || readonly"
      class="sli-icon-file__input"
      @change="onChange"
    >
    <label
      :for="inputId"
      class="sli-icon-file__hit"
      :title="tooltip"
    >
      <img
        v-if="iconSrc"
        :src="iconSrc"
        :alt="label"
        class="sli-icon-file__img"
      >
      <feather-icon
        v-else
        :icon="icon"
        size="16"
      />
      <span class="sli-icon-file__tick" />
    </label>
    <label
      :for="inputId"
      class="sli-icon-file__label"
      :title="tooltip"
    >{{ label }}</label>
    <div
      v-if="hasFile"
      class="sli-icon-file__actions"
    >
      <button
        v-if="canPreview"
        type="button"
        class="sli-map-btn"
        @click="$emit('preview')"
      >
        عرض
      </button>
      <button
        v-if="!readonly"
        type="button"
        class="sli-link-btn"
        @click="clear"
      >
        حذف
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliIconFile',
  props: {
    file: { default: null },
    existing: { type: Object, default: null },
    label: { type: String, required: true },
    inputId: { type: String, required: true },
    accept: { type: String, default: '' },
    validator: { type: Function, default: null },
    icon: { type: String, default: 'FileTextIcon' },
    iconSrc: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    canPreview: { type: Boolean, default: false },
    variant: { type: String, default: 'stack' },
  },
  data() {
    return { fileKey: 0 }
  },
  computed: {
    hasFile() {
      return !!(this.file || (this.existing && (this.existing.name || this.existing.url)))
    },
    displayName() {
      if (this.file && this.file.name) return this.file.name
      if (this.existing && this.existing.name) return this.existing.name
      return ''
    },
    tooltip() {
      if (this.displayName) return `${this.label}: ${this.displayName}`
      return `${this.label} — اضغط للرفع`
    },
  },
  methods: {
    onChange(event) {
      const picked = event.target.files && event.target.files[0]
      event.target.value = ''
      this.fileKey += 1
      if (!picked || this.disabled) return
      if (this.validator && !this.validator(picked)) {
        this.$toast.error(`نوع أو حجم الملف غير مسموح: ${picked.name}`)
        return
      }
      this.$emit('update:file', picked)
    },
    clear() {
      this.$emit('update:file', null)
      this.$emit('update:existing', null)
    },
  },
}
</script>
